import { Injectable, EventEmitter } from '@angular/core';    
import { Subscription } from 'rxjs/internal/Subscription';   
    
@Injectable({    
  providedIn: 'root'    
})    
export class EventEmitterService {    
    
  invokeManageBookingEvent = new EventEmitter();    
  subsVar: Subscription;    
    
  constructor() { }    
   

   // Trigger click event in header
  onHeaderComponentLinkClick() {
    this.invokeManageBookingEvent.emit();    
  }  
} 